<!--
  lovi
  设置密码 2020-1-9
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('common.setPassword')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper logReg-field">
      <ul>
        <li>
          <van-cell-group>
            <van-field
              clearable
              left-icon="icon-lock"
              :right-icon="eye ? 'eye-o' : 'closed-eye'"
              @click-right-icon="eye = !eye"
              :type="eye ? 'text' : 'password'"
              v-model="password"
              :error="error.password ? true : false"
              @input="verifyPsd"
              :placeholder="$t('common.PasswordFormat')"
            />
          </van-cell-group>
        </li>
        <li>
          <van-button
            round
            type="primary"
            block
            :loading="btnLoading"
            @click="submit"
          >
            {{ $t("common.confirm") }}
          </van-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import * as validate from "@/commonJs/validate.js";
export default {
  props: ["setPsdFlag"],
  name: "setPsd",
  meta: {
    power: false,
    service: false // 客服
  },
  components: {},
  data() {
    return {
      btnLoading: false, //按钮loadding
      eye: false,
      password: "",
      error: {
        password: false
      },

      routeData: {}
    };
  },
  created() {
    let vm = this;
    if (vm.setPsdFlag) {
      return false;
    }
    if (_.isEmpty(vm.$route.params)) {
      // 刷新页面要返回
      vm._back();
    } else {
      vm.routeData = this.$route.params;
    }
    console.log("routeData", this.routeData);
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回
      if (this.setPsdFlag) {
        this.$emit("update:setPsdFlag", false);
      } else {
        this._back();
      }
    },
    verifyPsd() {
      // 验证密码
      this.error.password = validate.validatePsd(this.password);
    },
    submit() {
      // 重置密码
      let vm = this;
      for (let key in vm.error) {
        if (vm.error[key]) {
          vm.$toast(vm.error[key]);
          return false;
        }
      }
      if (vm.password == "") {
        vm.$toast(vm.$t("common.enterPassword"));
        return false;
      }
      if (vm.setPsdFlag) {
        vm.$emit("getSetPsd", vm.password);
        // vm.$emit("update:setPsdFlag", false);
      } else {
        vm.forgetPassword();
      }
    },
    forgetPassword() {
      let vm = this;
      let params = {};
      params.phone = vm.routeData.phone;
      params.code = vm.routeData.code;
      params.password = vm.password;
      vm.btnLoading = true;
      vm.$post("/app/user/forgetPassword", params, { alert: true }).then(
        res => {
          vm.btnLoading = false;
          console.log("forgetPassword", res);
          vm.$toast(res.msg);
          if (res.code == 0) {
            localStorage.setItem("token", "");
            vm.$store.dispatch("SET_TOKEN", "");
            vm.$store.dispatch("GET_USER_INFO", { obj: "delete" });
            vm.$router.replace({
              path: "/logReg"
            });
          }
        }
      );
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.dialog-content {
  padding: 20px;
  text-align: center;
  font-size: 14px;
}
</style>
